import { h, Component } from 'preact'
import { Link } from 'preact-router'
import styled from 'styled-components'
import LogoImg from '../atoms/logo'
import Sizer_ from '../atoms/sizer'
import Underlined from '../atoms/underlined'
import { getType } from '../../data/index.mjs'

const Sizer = Sizer_.extend`
  display: flex;
  min-width: 750px;
`

const Spacer = styled.div`
  flex-grow: 1;
`

const HeaderBar = styled.header`
  width: 100%;
  background-color: #fcf666;
  height: 90px;
  line-height: 90px;
  position: fixed;
  border-bottom: solid 1px #bbb;
  z-index: 1000;
  padding-left: calc(100vw - 100%);
  overflow-y: hidden;
`

const HeaderBarInner = styled.div`
  /*remove this */
  height: 120px;
  overflow-y: hidden;
  overflow-x: auto;
  padding: 0 0 30px 0;
`

const LinkH1 = styled(Link)`
  color: black;
  display: block;
  text-decoration: none;
`

const H1 = styled.h1`
  margin: 0;
`

const Logo = styled(LogoImg)``

const LogoA = styled.a`
  height: 90px;
  padding-top: 14px;
  border-left: 1px solid #c8bf4b;
  padding-left: 20px;
`

const MenuItem = styled.a`
  text-decoration: none;
  font-size: 20px;
  line-height: 20px;
  border-left: 1px solid #c8bf4b;
  padding: 35px 20px 35px 20px;
  max-height: 90px;
  color: black;
  transition: background 0.2s;
  :hover {
    background: rgba(0, 0, 0, 0.05);
  }
  :hover ${Underlined}::after {
    opacity: 0;
  }
`

export default class Header extends Component {
  render() {
    return (
      <HeaderBar>
        <HeaderBarInner>
          <Sizer>
            <LinkH1 href="/">
              <H1>
                {getType() === 'mop'
                  ? 'Dotazník pro poslance'
                  : 'Dotazník pro prezidentské kandidáty'}
              </H1>
            </LinkH1>
            <Spacer />
            {getType() !== 'mop' ? null : this.props.url === '/vsichni' ? (
              <MenuItem href="/">
                <Underlined>Zvolení poslanci</Underlined>
              </MenuItem>
            ) : (
              <MenuItem href="/vsichni">
                <Underlined>Všichni politici</Underlined>
              </MenuItem>
            )}
            <LogoA href="http://rekonstrukcestatu.cz/">
              <Logo />
            </LogoA>
          </Sizer>
        </HeaderBarInner>
      </HeaderBar>
    )
  }
}



// WEBPACK FOOTER //
// ./components/header/index.js